import { Box, Typography, MenuItem } from "@mui/material"
import Select from '@mui/material/Select';

import PaginationForward from '@assets/svg/PaginationForward.svg?react';
import PaginationBack from '@assets/svg/PaginationBack.svg?react';
import useBreakPoinst from "@hooks/useBreakPoinst";
import { useTranslation } from "react-i18next";


const SInglePage = ({ lable = 1, isActive = true,onClick=()=>{} }) => {
    return (
        <Box sx={{
            width: '24px',
            height: '24px',
            borderRadius: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: isActive ? 'rgba(91, 63, 255, 1)' : 'rgba(255, 255, 255, 1)',
            color: isActive ? 'rgba(255, 255, 255, 1)' : 'rgba(91, 63, 255, 1)',
            mr: '10px',
            textAlign: 'center',
            cursor: 'pointer',
            boxShadow: ' 0px 2px 4px 0px rgba(0, 0, 0, 0.08)'
        }} >
            <Box onClick={onClick} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }} >
                {lable}
            </Box>
        </Box>
    )
}

const Pagination = ({ onBack=()=>{},onForwared=()=>{}, onPageClicked=(p:any)=>{},currenPage=1,numberOfPages=5,perPage=5,onPerpageChange=(v:any)=>{}}) => {
    const {isPhone} = useBreakPoinst();
    const {
		t,
	} = useTranslation()

    const WINDOW_SIZE = 6;
    const windowStart = Math.max(1, Math.min(currenPage - 2, numberOfPages - WINDOW_SIZE + 1));
    const windowEnd = Math.min(numberOfPages, windowStart + WINDOW_SIZE - 1);
    const visiblePages: number[] = [];
    for (let i = windowStart; i <= windowEnd; i++) visiblePages.push(i);

    const isFirstPage = currenPage === 1;
    const isLastPage = currenPage === numberOfPages;

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' ,mt:3}} >
            <Box sx={{ display: 'flex', alignItems: 'center' }} >
                <PaginationForward 
                    onClick={isFirstPage ? undefined : onBack}
                    style={{
                        width: '24px',
                        height: '24px',
                        cursor: isFirstPage ? 'not-allowed' : 'pointer',
                        transform: 'rotate(180deg)',
                        opacity: isFirstPage ? 0.3 : 1,
                    }}
                />

                <Box sx={{ display: 'flex', alignItems: 'center' }} >
                    {visiblePages.map((p) => (
                        <SInglePage key={p} lable={p} onClick={() => onPageClicked(p)} isActive={currenPage === p} />
                    ))}
                </Box>

                <PaginationForward
                    onClick={isLastPage ? undefined : onForwared}
                    style={{
                        width: '24px',
                        height: '24px',
                        cursor: isLastPage ? 'not-allowed' : 'pointer',
                        marginRight: '5px',
                        marginLeft: '5px',
                        opacity: isLastPage ? 0.3 : 1,
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }} >
                <Typography sx={{
                    color: 'rgba(142, 152, 161, 1)',
                    fontSize:isPhone?'10px': '14px',
                    fontWeight: 400,
                    mx: 1
                }} >
                    {t('RESULTPERPAGE')}
                </Typography> 
                <Select
                    sx={{
                        width: '65px',
                        height: '35px',
                        borderRadius: '8px',
                        color:'rgba(142, 152, 161, 1)',
                        

                    }}
                    value={perPage}
                    label=""
                    onChange={(v:any) => onPerpageChange(v.target.value)}
                >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                </Select>

            </Box>

        </Box>
    )
}

export default Pagination